const ArrowDown = (props: any) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7.99904 11.1985C7.53237 11.1985 7.0657 11.0185 6.71237 10.6651L2.3657 6.31846C2.17237 6.12513 2.17237 5.80513 2.3657 5.6118C2.55904 5.41846 2.87904 5.41846 3.07237 5.6118L7.41904 9.95846C7.73904 10.2785 8.25904 10.2785 8.57904 9.95846L12.9257 5.6118C13.119 5.41846 13.439 5.41846 13.6324 5.6118C13.8257 5.80513 13.8257 6.12513 13.6324 6.31846L9.2857 10.6651C8.93237 11.0185 8.4657 11.1985 7.99904 11.1985Z" fill="#333333"/>
    </svg>
  )
}

export default ArrowDown;